import * as React from 'react';

export const IconEmpty: React.FC = () => (
	<svg
		viewBox="0 0 24 24"
		width="24"
		height="24"
		stroke="currentColor"
		strokeWidth="2"
		fill="none"
		strokeLinecap="round"
		strokeLinejoin="round"
	></svg>
);
